import React, { FC, useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import s from './CardServices.module.scss'
import { BACKEND_URL } from '../../api'
import { Ilist_services } from '../../store/types'

interface dataProps {
    data: Ilist_services,
    isFirst?: boolean
    isCentered?: boolean
    cardRef?: React.RefObject<HTMLDivElement>
}

const CardServices: FC<dataProps> = ({
    data,
    isCentered = false,
    cardRef: externalRef
}) => {
    const internalRef = useRef<HTMLDivElement>(null)
    const cardRef = externalRef || internalRef
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 991)
        }
        checkMobile()
        window.addEventListener('resize', checkMobile)
        return () => window.removeEventListener('resize', checkMobile)
    }, [])

    const serviceVariants = {
        visible: { opacity: 1 },
        hidden: { opacity: 0 }
    }

    const detailVariants = {
        hidden: { x: '-100%', opacity: 0 },
        visible: { x: 0, opacity: 1 }
    }

    // ===== DESKTOP =====
    if (!isMobile) {
        return (
            <div ref={cardRef} className={s.card}>
                <div className={s.service}>
                    <img src={BACKEND_URL + data.icon_card} alt="icon" />
                    <h2>{data.name_card}</h2>
                </div>
                <div className={s.service_detail}>
                    <h3>{data.title_card}</h3>
                    <p>{data.description_card}</p>
                </div>
            </div>
        )
    }

    // ===== MOBILE =====
    return (
        <motion.div
            ref={cardRef}
            layout
            className={`${s.card} ${isCentered ? s.active : ''}`}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
            <motion.div
                className={s.service}
                variants={serviceVariants}
                initial={false}
                animate={isCentered ? 'hidden' : 'visible'}
                transition={{ duration: 0.25 }}
            >
                <img src={BACKEND_URL + data.icon_card} alt="icon" />
                <h2>{data.name_card}</h2>
            </motion.div>

            <motion.div
                className={s.service_detail}
                variants={detailVariants}
                initial={false}
                animate={isCentered ? 'visible' : 'hidden'}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
            >
                <h3>{data.title_card}</h3>
                <p>{data.description_card}</p>
            </motion.div>
        </motion.div>
    )
}

export default CardServices